import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  reply_id: string;
  title?: string;
  body?: string;
  category?: string;
};

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useUpdateQuickReplyMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while updating the quick reply',
    endpoint: ({ reply_id }) => `/api/admin/whatsapp/quick-reply/${reply_id}`,
    method: 'PUT',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
